import { resolveImagePath } from '@/utils/imageResolver';

export function Experience() {
  return (
    <section className="bg-blue-700 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          {/* Left side - Experience text */}
          <div className="text-center lg:text-left">
            <h2 className="text-4xl lg:text-5xl font-light mb-4">
              We've Been <span className="font-bold">Training Pilots</span> For
            </h2>
            <h3 className="text-4xl lg:text-5xl font-light text-blue-200">
              Over 40 Years!
            </h3>
          </div>

          {/* Right side - Call to action with image */}
          <div className="bg-blue-800 rounded-lg p-8 relative">
            <div className="text-center mb-6">
              <h3 className="text-2xl lg:text-3xl font-semibold mb-4">
                Sign Up for a Tour Today
              </h3>
              <p className="text-blue-100 text-lg mb-4">
                American Aviation Flight Academy can help you with all of your training needs with flexible classes, programs and pricing.
              </p>
              <h4 className="text-xl font-semibold mb-6">
                Contact us today to get started!
              </h4>
              <a
                href="/contact-us"
                className="inline-block bg-yellow-500 hover:bg-yellow-600 text-black font-semibold py-3 px-8 rounded-lg transition-colors duration-300"
              >
                Contact Us
              </a>
            </div>
            
            {/* Aircraft image */}
            <div className="mt-6 rounded-lg overflow-hidden">
              <img
                src={resolveImagePath('/images/footer-bg.jpg')}
                alt="Aircraft on runway at sunset"
                className="w-full h-32 object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}